/* eslint-disable react/button-has-type */
import { ButtonHTMLAttributes, FC } from 'react';
import classNames from 'classnames';

import { Typography } from '../Typography/Typography';
import styles from './Button.module.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	size?: 'default' | 'medium' | 'small';
	isLoading?: boolean;
	variant?: 'primary' | 'secondary' | 'tertiary';
	width?: string;
}

export const Button: FC<ButtonProps> = ({
	children,
	variant = `primary`,
	size = `default`,
	disabled = false,
	isLoading = false,
	width,
	className,
	...props
}) => {
	const { Text } = Typography;

	return (
		<button
			className={classNames(
				styles.button,
				disabled || isLoading ? styles[`button__disabled--${variant}`] : styles[`button__main--${variant}`],
				styles[`button__size--${size}`],
				className,
			)}
			style={{ width }}
			disabled={disabled || isLoading}
			{...props}
		>
			<Text variant='button-md'>{children}</Text>
		</button>
	);
};
